export const CONNECTION_STATUS = {
    NO_CONNECTION: 0,
    CREATED: 1,
    ACCEPTED: 2,
    DECLINED: 3,
    CANCELLED: 4,
    FOLLOWING: 5, // old following status. might be remove/replace/reused
    BLOCKING: 6,
    BLOCKED: 7,
    MUTED: 8
};

export const isStatusNoConnection = (statusCode) => {
    return statusCode === CONNECTION_STATUS.NO_CONNECTION;
};
export const isStatusAccepted = (statusCode) => {
    return statusCode === CONNECTION_STATUS.ACCEPTED;
};
export const isStatusCreated = (statusCode) => {
    return statusCode === CONNECTION_STATUS.CREATED;
};
export const isStatusBlocking = (statusCode) => {
    return statusCode === CONNECTION_STATUS.BLOCKING;
};
export const isStatusMuted = (statusCode) => {
    return statusCode === CONNECTION_STATUS.MUTED;
};

export const isAbleToConnect = (statusCode) => {
    return statusCode === CONNECTION_STATUS.NO_CONNECTION;
};

export const shouldShowChallengeButton = (statusCode) => {
    return statusCode === CONNECTION_STATUS.ACCEPTED || statusCode === CONNECTION_STATUS.MUTED;
};

export const shouldShowBlockButton = (statusCode) => {
    return (
        statusCode !== CONNECTION_STATUS.ACCEPTED &&
        statusCode !== CONNECTION_STATUS.BLOCKING &&
        statusCode !== CONNECTION_STATUS.MUTED
    );
};
